import SETS from './sets.json';
import MATERIALS from './materials.json';

export default {
  SETS,
  MATERIALS
}
